import ErrorMessages from "../../common/ErrorMessages";
import ToffErrMessages from "../../common/ToffErrMessages";
const PaperlessBillingContainerHelper = {

  submitClick() {
    window.aUtils.sendAAEvent("button","paperlessBillingTurnOn");
    this.popupCallback();
    let updatedState = { ...this.state };
    if (!_.isEmpty(updatedState.data)) {
      updatedState.accountObj = this.state.data.map(function (selectedcact) {
        return { customerAccountNumber: selectedcact,contractAccountNumber: selectedcact,};
      });
      
    }
    else {
      let cact = parseInt(this.props.accountData.contractAccountNumber);
      updatedState.accountObj = [{ customerAccountNumber: cact,contractAccountNumber: cact}];
      
    }
     app.logger.getLogger().info("Paperless Billing Enroll: Submit");
     if (!this.checkLoginEmail() && _.isEmpty(this.customerData.emailAddresses)) {
      let loginEmail = { value: app.appService.getUserInfo().email };
      app.centralizedService.getPaperlessBillingModifyCustPrefs(loginEmail, 'I').then(
        (response) => {
          app.centralizedService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData,updatedState.unselected,updatedState.selectAllflag,this.state.contractAccountCount).then(
            (res) => {
              updatedState.enrolledCount=res.length,updatedState.enrollResponse=res;
              //updatedState.isPbEnrollConfirm = true;
              if(res[0].transactionOutcome){
                errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome];
                deEnrollPbErrMsg = ToffErrMessages[res[0].transactionOutcome];
                updatedState.pbEnrollErrMsg=errorPbEnrollMsg, updatedState.enrollResponse=res, updatedState.errorPbDeEnrollMsg=deEnrollPbErrMsg;
                
               }else{
                updatedState.isPbEnrollConfirm = true;
               if(res.length===1 && res[0].transactionOutcome===null){
                updatedState.enrolledCact = res[0].accountNumber;

                }
              else{
              updatedState=this.bulkEnrollFailureCounts(res,updatedState);
              }
             
              updatedState.enrolledCact = res.contractAccountNumber,updatedState.checked = true,updatedState.confirmObj = res;
              updatedState.pbEnroll=false;
            
            }
            window.scrollTo(0, 0);
            this.setState(updatedState);
           
          },
            (error) => {
              updatedState.checked = false,updatedState.isPbEnrollConfirm = false, updatedState.pbBulkEnrollConfirm = true,updatedState.isPbEnrollConfirm = true;//updatedState.errorEnrollFlag=true;
              this.handleServiceError(error);
              this.setState(updatedState);
            }
          );
        }, (error) => {
         
          updatedState.checked = false,
          this.handleServiceError(error);
          this.setState(updatedState);

        }
      );

    }

    else {
      
        app.centralizedService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData,updatedState.unselected,updatedState.selectAllflag,this.state.contractAccountCount).then(
        (res) => {
          updatedState.enrolledCount=res.length,updatedState.enrollResponse=res;
          let errorPbEnrollMsg='';
          let deEnrollPbErrMsg='';
          if(res[0].transactionOutcome){
            errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome];
            deEnrollPbErrMsg = ToffErrMessages[res[0].transactionOutcome];
            updatedState.pbEnrollErrMsg=errorPbEnrollMsg, updatedState.enrollResponse=res, updatedState.errorPbDeEnrollMsg=deEnrollPbErrMsg;
            }else{
              updatedState.isPbEnrollConfirm = true;
              if(res.length===1 && res[0].transactionOutcome===null){
                  updatedState.enrolledCact = res[0].accountNumber;

                }
                else{
                updatedState= this.bulkEnrollFailureCounts(res,updatedState);
               }
                
         updatedState.enrolledCact = res.contractAccountNumber,updatedState.confirmObj = res,updatedState.checked = true;
         updatedState.pbEnroll=false;
         }
            window.scrollTo(0, 0);
            this.setState(updatedState);
         
        },
       
        (error) => {
         
          updatedState.checked = false,updatedState.isPbEnrollConfirm = false,
          this.handleServiceError(error);
          this.setState(updatedState);
          
        }
      );
    }
},

  submitDeenrollClick() {
    window.aUtils.sendAAEvent("button","paperlessBillingTurnOff");
    const updatedState = { ...this.state };
    let currPaprRecord = this.props.depaprRecord || this.props.desinglePaprRecord;
    app.logger.getLogger().info("Paperless Billing DeEnroll: Submit");
    app.centralizedService.getPaperlessBillingDeEnrollDetails(this.props.accountData.bpNumber, currPaprRecord.record, app.appService.getUserInfo().profileData, this.props.accountData.contractAccountNumber).then(
      (res) => {
        let errorPbMsg='';
        updatedState.confirmObj = res,updatedState.checked = false, updatedState.pbDeEnroll = false, updatedState.deEnrollConfirmPopup = true,updatedState.yesCancelDeEnroll = true;//to close turn off popup 
        window.scrollTo(0, 0);
        this.setState(updatedState);
      },
      (error) => {
        updatedState.checked = true,updatedState.isPbDeEnrollConfirm=false,updatedState.errorPbDeEnrollMsg=true;        
        this.handleServiceError(error);
        this.setState(updatedState);
      }
    );

  }
};
export default PaperlessBillingContainerHelper;
